
<script>

import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import { apiORDSpost, apiORDS, apiDateORDS } from "../shared/api-functions";
import { getText, formatDataHoraExtenso } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            show: false,
            metadata: this.$store.getters.getEntities.metadata,
            colunas: [],
            total: [],
            dados: null,
            filter: {            //objeto utilizado pelo filtro de mes
                startDate: null,
                endDate: null,
            },

            
        }
    },

    components: {
        BarList, BarGrid
    },

    computed: {
        leadList: function () {
            return this.$store.getters.getLeadCrmList
        },
    },

    watch: {

    },

    filters: {

    },

    methods: {
        blurValores (mes) {
            // AO SAIR DO CAMPO DE VALOR, EFETUA A TOTALIZACAO DA COLUNA CORRESPONDENTE AO MES
            let idx = this.dados.meses.indexOf(mes)
            let tot = 0
            for (var y = 0; y < this.dados.usuarios.length; y++) {
                tot = tot + Number(this.dados.usuarios[y].valores[idx].valor_meta)
            }
            this.$set(this.total, idx, tot)
        },

        handleMonthChange (data) {
            this.filter.endDate = this.$lastDay(this.$addMonths(this.filter.startDate, 11))
            this.loadData()
        },

        loadColunas () {
            this.show = false

            this.colunas = [
                { nome: 'usuario', visible: true, label: 'Usuário', sortable: false, orderby: null, class: '', style: 'min-width: 280px;' },
            ]

            if (!this.dados)
              return
                        
            let m = null
            let month = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
            
            for (var x = 0; x < this.dados.meses.length; x++) {
                m = this.dados.meses[x]
                const [ano, mes] = m.split("-")
                this.colunas.push({ nome: m, label: month[mes-1] + '/' + ano, visible: true, class: 'size130' })
            }

            let valores = null
            let idx = null

            for (var x = 0; x < this.dados.usuarios.length; x++) {
                //pega as metas correspondentes ao usuario em dados.valores
                valores = this.dados.valores.filter((obj) => {
                    return obj.id == this.dados.usuarios[x].id
                })

                this.dados.usuarios[x].valores = []
                for (var y = 0; y < this.dados.meses.length; y++) {
                    this.dados.usuarios[x].valores.push({ mes: this.dados.meses[y], valor_meta: null })
                }

                if (valores[0]) {
                    for (var y = 0; y < valores[0].meses.length; y++) {
                        idx = this.dados.meses.indexOf(valores[0].meses[y].mes)
                        this.dados.usuarios[x].valores[idx].valor_meta = valores[0].meses[y].valor_meta
                    }
                }

            }

            // efetua a totalizacao das metas

            this.total = []
            let tot = 0
            for (var x = 0; x < this.dados.meses.length; x++) {
                tot = 0
                for (var y = 0; y < this.dados.usuarios.length; y++) {
                    tot = tot + this.dados.usuarios[y].valores[x].valor_meta
                }
                this.total.push(tot)
            }

            this.show = true
        },

        closeForm() {
            this.$modalForm(false)
            this.$router.push('/consultas/vendas-vendedor')
        },

        async loadData() {
            // apiORDS(this.$store.getters.urlOrds + 'crm/email/count', null, true).then((result) => { 
            //     if (result.items.length > 0)
            //     SysVars.countEmail = result.items[0].email
            //     else 
            //     SysVars.countEmail = null

            let q = '?after=' + apiDateORDS(this.filter.startDate) + '&before=' + apiDateORDS(this.filter.endDate, true)
            const data = await apiORDS(this.$store.getters.urlOrds + 'cg/metav/' + q, null)
            this.dados = data
            this.loadColunas()
        },

        handleSalvar () {
           this.apiPost()
        },

        handleCancelar () {
            this.loadData()
        },

        async apiPost () {
            //efetua a gravacao

            let metas = []
            let obj = null

            for (var x = 0; x < this.dados.usuarios.length; x++) {
                obj = { idusuario: this.dados.usuarios[x].id, valores: [] }

                for (var y = 0; y < this.dados.usuarios[x].valores.length; y++) {
                    const [ano, mes] = this.dados.meses[y].split("-")
                    const dt = this.$firstDay(ano + '-' + mes + '-01')
                    obj.valores.push({ data: dt, valor_meta: this.dados.usuarios[x].valores[y].valor_meta })
                }
                metas.push(obj)
            }

            var modulo = 'cg/metav/'
            var sendData = { metas: metas }

            const data = await apiORDSpost(this.$store, modulo, sendData, 'post')
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                this.$erpToastUpdated()
                this.errmessages = {}
                this.closeForm()
            }
        },

    },

    created () {
        this.filter.startDate = this.$firstDay(this.$getDate())
        this.filter.endDate = this.$lastDay(this.$addMonths(this.filter.startDate, 11))
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-if="show"> 
            <!-- 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="true"
                single-entity="Lead" 
                plural-entity="Leads"
                @search="textSearch"
                @new="handleNovo"
                @refresh="loadData">
            </bar-list> 
            -->

            <div class="border mb-2" style="padding: 15px 0px 0 15px; background: #fff">
                <div class="row">
                    <div class="col-md-6 col-12 def-title mb-2">
                        METAS DE VENDA POR USUÁRIO/VENDEDOR
                    </div>
                    <div class="col-md-6 col-12 text-right">
                        <v-button label="Salvar" :nb-btdef="true" @click="handleSalvar"></v-button>
                        <v-button label="Cancelar" @click="handleCancelar"></v-button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 col-4 mb-2">
                        <input-month :p-month="filter" :show-options="false" @monthChange="handleMonthChange"></input-month>
                    </div>
                </div>
            </div>

            <div class="default-container">
                    <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
                        <div style="overflow: auto">
                            <table class="table table-hover responsive tablesorter w-100">
                                <thead>
                                    <tr>
                                        <template v-for="col in colunas">
                                            <th :class="col.class" :style="col.style">{{ col.label }}</th>
                                        </template>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in dados.usuarios" :key="index">
                                        <td :style="colunas[0].style" :class="colunas[0].class">{{ row.nome }}</td>
                                        <template v-for="valor in row.valores">
                                            <th style="min-width: 130px">
                                                <input-value v-model="valor.valor_meta" class="form-control form-control-sm" :precision="2" @blur="blurValores(valor.mes)"></input-value>
                                            </th>
                                        </template>
                                    </tr>
                                </tbody>   
                                <tfoot>
                                    <tr>
                                        <th class="text-right total">Total</th>
                                        <template v-for="tot in total">
                                            <th class="numerico total">
                                                <span>{{ tot | formatValue(2) }}</span>
                                            </th>
                                        </template>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

            </div>

        </div>
    </div>
</template>


<style>


</style>



// WEBPACK FOOTER //
// src/forms/metavendas-form.vue